import React from "react";
import { default as MUILink } from "@mui/material/Link";
import styled from "styled-components";

const StyledMUILink = styled(MUILink)``;

export const Link = (props) => {
  return <StyledMUILink {...props} />;
};
